import { render, staticRenderFns } from "./qrwhatsApp.vue?vue&type=template&id=7f61c95e&scoped=true"
import script from "./qrwhatsApp.vue?vue&type=script&lang=js"
export * from "./qrwhatsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61c95e",
  null
  
)

export default component.exports